import type { LibraryData } from '@/core/types/library.type'

export function getPathForTypeName(libraries: Record<string, LibraryData>, typeName: string): string[] | null {
  if (!typeName?.trim()) return null

  const normalized = typeName.trim()

  for (const [libraryName, library] of Object.entries(libraries)) {
    const classes = library.classes
    if (!classes) continue

    for (const [classKey, classData] of Object.entries(classes)) {
      let fullName = classKey

      if (classData.namespace && classData.namespace !== '.') {
        fullName = `${classData.namespace}.${classData.name}`
      }

      if (normalized === fullName) {
        return [libraryName, classKey]
      }
    }
  }

  return null
}
